import {ajax} from './ajax';

export function CheckToken(){
    return ajax('tokenJson', '/account/checkToken', 'GET', false)
}